import { removeDuplicates } from '@helpers/utilities'
import { ON_NAVIGATION } from '@state/actions/appActions'
import {
  SET_CATEGORY_FILTER,
  SET_LEVEL_FILTER,
  SET_SCHOOL_YEAR_FILTER,
  SET_SUBJECT_FILTER,
  RESET_FILTERS,
  SET_FILTERED_ITEMS,
} from '@state/actions/filtersActions'

const initialFiltersState = {
  subjectFilter: undefined,
  schoolYearFilter: undefined,
  levelFilter: undefined,
  categoryFilter: undefined,
  filteredItems: [],
}

/**
 * Reducer
 */
const filtersReducer = (state, action) => {
  switch (action.type) {
    case SET_SUBJECT_FILTER:
      return {
        ...state,
        subjectFilter: action.payload,
      }

    case SET_SCHOOL_YEAR_FILTER:
      return {
        ...state,
        schoolYearFilter: action.payload,
      }

    case SET_LEVEL_FILTER:
      return {
        ...state,
        levelFilter: action.payload,
      }

    case SET_CATEGORY_FILTER:
      return {
        ...state,
        categoryFilter: action.payload,
      }

    case ON_NAVIGATION:
    case RESET_FILTERS:
      return {
        ...initialFiltersState,
        filteredItems: state.filteredItems,
      }

    case SET_FILTERED_ITEMS:
      return {
        ...state,
        filteredItems: removeDuplicates(action.payload.items),
      }

    default:
      return state
  }
}

export { initialFiltersState, filtersReducer }
